<template>
	<section>
		<el-table
			fit
			ref="filterTable"
			row-key="id"
			border
			default-expand-all
			:data="commitmentScheduleData"
			style="width: 100%; margin-top: 20px"
		>
			<el-table-column label="Financier" width="130" prop="financier">
                <template slot-scope="scope">
                    {{scope.row.childElement ? '' : scope.row.financier ? scope.row.financier : 'Other'}}
                </template>
            </el-table-column>

			<el-table-column label="Start" width="130" prop="startDate">
				<template slot-scope="scope">
                    <span v-if="scope.row.startDate">{{ scope.row.startDate | moment("DD/MM/YYYY") }}</span>
				</template>
			</el-table-column>

			<el-table-column align="right" header-align="center" label="Monthly Repayment" width="200">
				<template slot-scope="scope">
					{{ calulateMonthly(scope.row) }}
				</template>
			</el-table-column>

			<el-table-column label="End" width="130" prop="endDate">
				<template slot-scope="scope">
                    <span v-if="scope.row.endDate">{{ scope.row.endDate | moment("DD/MM/YYYY") }}</span>
				</template>
			</el-table-column>

			<el-table-column label="Type" width="150">
				<template slot-scope="scope">
					{{
						_.get(
							loanTypes.find((type) => type.value == scope.row.loan_type),
							"label"
						)
					}}
				</template>
			</el-table-column>

			<el-table-column width="350" label="Item" prop="assetLiabilityType.label"></el-table-column>

			<el-table-column
				align="center"
				header-align="center"
				label="Status"
				min-width="150"
				max-width="250"
				prop="status"
			></el-table-column>

			<el-table-column align="right" header-align="center" label="Cost" width="150" prop="asset_cost">
				<template slot-scope="scope">
					{{ formatCurrency(scope.row.asset_cost, 2) }}
				</template>
			</el-table-column>

			<el-table-column align="right" header-align="center" width="200" label="A/C Number" prop="account_number"></el-table-column>
		</el-table>
	</section>
</template>

<script>
	import { mapGetters } from "vuex"
	export default {
		name: "CommitmentSchedule",
		components: {},
		props: {
			assetsAndLiabilities: {
				// required: true,
			},
		},
		data() {
			return {
				frequencies: [
					{ count: 52, value: 4, days: 7 },
					{ count: 26, value: 2, days: 14 },
					{ count: 12, value: 1, days: (this.$moment().isLeapYear() ? 366 : 365) / 12 },
					{ count: 4, value: 0.333333333, days: (this.$moment().isLeapYear() ? 366 : 365) / 4 },
					{ count: 1, value: 0.083333333, days: this.$moment().isLeapYear() ? 366 : 365 },
				],
			}
		},
		computed: {
			...mapGetters({ loanTypes: "options/loanTypes" }),
			commitmentScheduleData() {
				let schedule = this.assetsAndLiabilities.filter((row) => row.ownedOutright)
				let groupedSchedule = _.map(_.groupBy(schedule, "financier"), (schedule, financier) => ({ financier, schedule }))
				let scheduleData = groupedSchedule.map((sc, index) => {
					let newSchedule = sc.schedule[0]
					sc.schedule.shift()
                    let children = sc.schedule.map((child, childIndex) => {
                        Vue.set(child, 'id', parseInt(`${index + 1}${childIndex + 1}`))
                        Vue.set(child, 'childElement', true)
                        return child
                    })
					Vue.set(newSchedule, "children", children)
                    Vue.set(newSchedule, "childElement", false)
					Vue.set(newSchedule, "id", index + 1)
					return newSchedule
				})

                let sortedScheduleData = _.sortBy(scheduleData, [o => { return o.financier; }]);
				return sortedScheduleData
			},
		},
		watch: {},
		mounted() {},
		updated() {},
		activated() {},
		methods: {
			calulateMonthly(row) {
				let check = this.$moment(this.$moment(), "YYYY/MM/DD")
				let month = check.format("M")
				let yearBegins = (month >= 1 && month <= 6 ? new Date().getFullYear() - 1 : new Date().getFullYear()) + "/07/01"
				let frequency = this.frequencies.find((i) => row.frequency == i.value)

				//   Calculated YTD based on the start of the finacial year and amount of payments passed.
				//   let result = Number(
				//     (_.get(row, "repaymentAmount", _.get(row, "v")) * this.$moment(check).diff(yearBegins, "days")) /
				//       _.get(frequency, "days", 7)
				//   ).toFixed(2)

				let monthly = (
					Number(
						(_.get(row, "repaymentAmount", _.get(row, "v")) * (this.$moment().isLeapYear() ? 366 : 365)) /
							_.get(frequency, "days", 7)
					) / 12
				).toFixed(2)

				row.monthyRepayment = this.formatCurrency(monthly, 2)
				return this.formatCurrency(monthly, 2)
			},
			formatCurrency(amount, decimals = 0) {
				let currencyFormatter = new Intl.NumberFormat("en-US", {
					style: "currency",
					currency: "USD",
					minimumFractionDigits: decimals,
					maximumFractionDigits: decimals,
				})
				return currencyFormatter.format(amount)
			},
		},
	}
</script>

<style lang="scss" scoped>
	// @import '@assets/sass/backend/_core-variables.scss';
	h4 {
		padding: 0.5rem 1rem;
		color: #2493ef !important;
		font-size: 1.1rem !important;
	}
</style>
